const validarIp = (ip, options = "") => {
  const ipv6Regex =
    /^(?:(?:[A-F0-9]{1,4}(?::[A-F0-9]{1,4})*)?::)?(?:[A-F0-9]{1,4}(?::[A-F0-9]{1,4})*)?$/i;
  const ipv6RegexWithMask =
    /^(?:(?:[A-F0-9]{1,4}(?::[A-F0-9]{1,4})*)?::)?(?:[A-F0-9]{1,4}(?::[A-F0-9]{1,4})*)?\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/i;
  const ipv6RegexWithPort =
    /^(?:(?:[A-F0-9]{1,4}(?::[A-F0-9]{1,4})*)?::)?(?:[A-F0-9]{1,4}(?::[A-F0-9]{1,4})*)?:\d{1,5}$/i;
  const ipv4Regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}$/;
  const ipv4RegexWithMask =
    /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[1-2]?[0-9])$/;
  const ipv4RegexWithPort =
    /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?):(\d{1,5})$/;

  const validarBlocoIPv4 = (bloco) => {
    const partes = bloco?.split("/");
    if (partes?.length !== 2) return false;

    const mascara = parseInt(partes[1], 10);
    if (mascara < 0 || mascara > 32 || isNaN(mascara)) return false;

    return ipv4Regex?.test(partes[0]);
  };

  const validarBlocoIPv6 = (bloco) => {
    const partes = bloco?.split("/");
    if (partes.length !== 2) return false;

    const prefixo = parseInt(partes[1], 10);
    if (prefixo < 0 || prefixo > 128 || isNaN(prefixo)) return false;

    // Validação adicional para IPv6
    const ip = partes[0];
    if ((ip?.match(/::/g) || [])?.length > 1) return false;
    if (ip?.startsWith(":") && !ip?.startsWith("::")) return false;
    if (ip?.endsWith(":") && !ip?.endsWith("::")) return false;

    return ipv6Regex.test(ip);
  };

  switch (options) {
    case "justMask":
      if (ipv6RegexWithMask.test(ip)) {
        return 1;
      }
      if (ipv4RegexWithMask.test(ip)) {
        return 1;
      }
      return 0;

    case "justPort":
      if (ipv6RegexWithPort.test(ip)) {
        return 1;
      }
      if (ipv4RegexWithPort.test(ip)) {
        return 1;
      }
      return 0;

    case "justIp": {
      if (ipv6Regex.test(ip)) {
        return 1;
      }
      if (ipv4Regex.test(ip)) {
        return 1;
      }
      return 0;
    }

    case "justIpv6": {
      if (ipv6Regex.test(ip)) {
        return 1;
      }
      return 0;
    }

    case "justIpv4": {
      if (ipv4Regex.test(ip)) {
        return 1;
      }
      return 0;
    }

    case "justIpv4Mask": {
      if (ipv4RegexWithMask.test(ip)) {
        return 1;
      }
      return 0;
    }

    case "justIpv6Mask": {
      if (ipv6RegexWithMask.test(ip)) {
        return 1;
      }
      return 0;
    }

    case "justBloco": {
      if (validarBlocoIPv4(ip)) {
        return 1;
      }
      if (validarBlocoIPv6(ip)) {
        return 1;
      }
      return 0;
    }

    case "justBlocoIPv4": {
      return validarBlocoIPv4(ip) ? 1 : 0;
    }

    case "justBlocoIPv6": {
      return validarBlocoIPv6(ip) ? 1 : 0;
    }

    default:
      if (
        ipv6Regex.test(ip) ||
        ipv6RegexWithMask.test(ip) ||
        ipv6RegexWithPort.test(ip)
      ) {
        return 1;
      }
      if (
        ipv4Regex.test(ip) ||
        ipv4RegexWithMask.test(ip) ||
        ipv4RegexWithPort.test(ip)
      ) {
        return 1;
      }
      return 0;
  }
};

module.exports = validarIp;
